import { PriceSummary } from "../PriceSummary";
const transformPriceModel = (priceModel: PriceModel) => {
  return priceModel.installmentCount
    ? {
        downpaymentAmount: priceModel.downpaymentAmount,
        installmentCounts: [
          {
            labels: [`${priceModel.installmentCount} Monthly payments of`],
            value: priceModel.installmentAmount,
          },
        ],
        annualPaymentAmount: priceModel.totalPaymentAmount,
      }
    : {
        downpaymentAmount: priceModel.totalPaymentAmount,
        installmentCounts: [],
        annualPaymentAmount: priceModel.totalPaymentAmount,
      };
};
interface PriceModel {
  downpaymentAmount?: string;
  annualPaymentAmount?: string;
  installmentCount: number;
  installmentAmount: string;
  totalPaymentAmount: string;
}
export interface PersistentPriceSummaryProps {
  priceModel: PriceModel;
}
export function PersistentPriceSummary({
  priceModel,
}: PersistentPriceSummaryProps) {
  const transformedPriceModel = transformPriceModel(priceModel);
  return (
    <div className="persistent_price_summary">
      <PriceSummary priceModel={transformedPriceModel} />
    </div>
  );
}
